import styled from 'styled-components'
import globals from '../globals'

const { fonts } = globals;

export const H1 = styled.h1`
  font-size: ${globals.headings.h1};
  font-family: ${props => props.font ? fonts[props.font] : globals.fonts.headings};
  font-weight: ${props => props.weight || 'inherit'};
  font-style: ${props => props.fontStyle || 'initial'};
`

export const H2 = styled.h2`
  font-size: ${globals.headings.h2};
  font-family: ${props => props.font ? fonts[props.font] : globals.fonts.headings};
  font-weight: ${props => props.weight || 'inherit'};
  font-style: ${props => props.fontStyle || 'initial'};
`

export const H3 = styled.h3`
  font-size: ${globals.headings.h3};
  font-family: ${props => props.font ? fonts[props.font] : globals.fonts.headings};
  font-weight: ${props => props.weight || 'inherit'};
  font-style: ${props => props.fontStyle || 'initial'};
`

export const H4 = styled.h4`
  font-size: ${globals.headings.h4};
  font-family: ${props => props.font ? fonts[props.font] : globals.fonts.headings};
  font-weight: ${props => props.weight || 'inherit'};
  font-style: ${props => props.fontStyle || 'initial'};
`

export const H5 = styled.h5`
  font-size: ${globals.headings.h5};
  font-family: ${props => props.font ? fonts[props.font] : globals.fonts.headings};
  font-weight: ${props => props.weight || 'inherit'};
  font-style: ${props => props.fontStyle || 'initial'};
`

export const H6 = styled.h6`
  font-size: ${globals.headings.h6};
  font-family: ${props => props.font ? fonts[props.font] : globals.fonts.headings};
  font-weight: ${props => props.weight || 'inherit'};
  font-style: ${props => props.fontStyle || 'initial'};
`